import './profile.scss';

import { React, useContext, useState } from 'react';

import ProfileImage from 'components/layouts/playing-card.js/profile-image';
import {Resizable} from 're-resizable';
import { SettingsContext } from 'context/context';
import Stats from 'components/layouts/card/stats/stats';
import Wounds from 'components/layouts/card/wounds/wounds';

const Profile = ({info}) => {
  const [unitName, setUnitName] = useState('---');
  const { state } = useContext(SettingsContext);

  return (
    <div className={`profile ${state.addImage ? 'with-image' : null}`}>
      { state.addImage && state.cardOrientation === 'vertical' ? (
        <Resizable className="profile-image">
          <ProfileImage className="card-image" />
        </Resizable>
      ) : null }
      { state.addImage && state.cardOrientation !== 'vertical' ? (
        <div className="profile-image">
          <ProfileImage className="card-image" />
        </div>
      ) : null }
      <div className={`character ${state.personalize ? 'personalized' : ''}`}>
        <span className="unit_type" dangerouslySetInnerHTML={{__html: `${info.operativeType}`}} />
          { state.personalize ?
            <span className="unit_name">
              <input type="text" name="personalized-name" value={unitName} onChange={e => setUnitName(e.target.value)} />
            </span> : null}
        <Wounds wounds={info.stats.W} />
      </div>
      {/* <Resizable className={`character ${state.personalize ? 'personalized' : ''}`}>

      </Resizable> */}
      <Stats stats={info.stats} />
    </div>
  );
};

export default Profile;
